export default __webpack_public_path__ + "static/media/coins.f30cf400.svg";